'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { Row, Col, Container, Button } from 'reactstrap';
import TestimonialTile from 'shared/components/TestimonialTile';
import RegistrationForm from 'shared/components/RegistrationForm';
import CandidateSearchIcon from 'shared/components/svg/CandidateSearchIcon';
import useScrollHeight from 'shared/hooks/useScrollHeight';
import { useParams } from 'next/navigation';
import Link from 'next/link';
import { Dictionaries } from 'shared/i18n/i18n-config';
import { getI18nUtils } from 'shared/i18n/i18n-utils';
import AppLayout from '../../../../components/AppLayout';
import { Timeline, TimelineElement } from '../../../../components/Timeline';

const ContentSection = ({ header, image, content, flip = false }) => {
  const orderImg = flip ? 1 : 0;
  const orderContent = flip ? 0 : 1;
  return (
    <Container tag="section" className="py-0 py-md-5">
      <Row className="align-items-center my-md-5">
        <Col sm={12} md={{ size: 6, order: orderImg }} className="px-0 px-md-5 content-image">
          {image}
        </Col>
        <Col sm={12} md={{ size: 6, order: orderContent }} className="ps-4 pt-5 pt-md-0 mb-5 mb-md-1">
          <h2 className="mb-4">{header}</h2>
          {content}
        </Col>
      </Row>
    </Container>
  );
};

type Props = {
  dictionary: Partial<Dictionaries>;
};
export default function Consultants({ dictionary }: Props) {
  const { formatMessage } = getI18nUtils(dictionary);
  const params = useParams();
  const { locale } = params || {};
  const scrollHeight = useScrollHeight();

  const scrollToForm = () => {
    const formPosition = document.getElementById('registrationForm-section');
    formPosition?.scrollIntoView({ behavior: 'smooth' });
  };
  const fabDisplayClass = scrollHeight > 500 ? 'fixed-bottom' : 'd-none';

  const timelineElements = [
    ['jumptosynergie_consultants_timeline_1_title', 'jumptosynergie_consultants_timeline_1_p'],
    ['jumptosynergie_consultants_timeline_2_title', 'jumptosynergie_consultants_timeline_2_p'],
    ['jumptosynergie_consultants_timeline_3_title', 'jumptosynergie_consultants_timeline_3_p'],
    ['jumptosynergie_consultants_timeline_4_title', 'jumptosynergie_consultants_timeline_4_p'],
    ['jumptosynergie_consultants_timeline_5_title', 'jumptosynergie_consultants_timeline_5_p'],
  ].map(([title, p]) => [formatMessage({ id: title }), formatMessage({ id: p })]);

  return (
    <AppLayout
      dictionary={dictionary}
      className="jumpToSynergiePage"
      pageHeader={{
        backgroundUrl: '/headers/header_jump.jpg',
        backgroundUrlMobile: '/headers/header_jump_mobile.jpg',
        type: 'fullWidthImg',
        bigHeader: true,
      }}
      availableLocales={[{ locale: 'nl', pathname: '/jump-to-synergie' }]}
    >
      {/* INTRO: "Maak je sprong" + CTA */}
      <Container tag="section" className="py-md-5 mb-md-3 my-5">
        <Col sm={12} lg={{ offset: 3, size: 6 }}>
          <h1 id="pageTitle" className={`py-2 mb-4${locale === 'nl' ? ' text-wrap' : ''}`}>
            {formatMessage({ id: 'jumptosynergie_consultants_intro_title' })}
          </h1>
          <p>{formatMessage({ id: 'jumptosynergie_consultants_intro_p' })}</p>
          <Button color="primary" className="px-4 my-3" onClick={scrollToForm}>
            {formatMessage({ id: 'jumptosynergie_cta' })}
          </Button>
        </Col>
      </Container>

      {/* TIMELINE: "Jouw opleidingstraject" */}
      <div className="bg-light  py-lg-5">
        <Container tag="section" className="py-5">
          <Row className="text-md-center g-0">
            <Col sm={12} lg={{ size: 8, offset: 2 }}>
              <h2 className="py-2 mb-3">{formatMessage({ id: 'jumptosynergie_section2_title' })}</h2>
            </Col>
            <Col sm={12} lg={{ size: 6, offset: 3 }}>
              <p className="container px-md-0">{formatMessage({ id: 'jumptosynergie_consultant_section2_intro' })}</p>
              <p className="container px-md-0">{formatMessage({ id: 'jumptosynergie_consultant_section2_intro_2' })}</p>
            </Col>
            <Col sm={12} lg={{ size: 8, offset: 2 }}>
              <h3 className="py-2 mb-2 mt-4">{formatMessage({ id: 'jumptosynergie_section2_subtitle' })}</h3>
            </Col>
            <Col sm={12} lg={{ size: 6, offset: 3 }}>
              <p className="container px-md-0">{formatMessage({ id: 'jumptosynergie_consultant_section2_intro_3' })}</p>
            </Col>
          </Row>
        </Container>
        <Container tag="section" className="py-lg-3">
          <Timeline>
            {/* Empty timeline element to render the start of the axis */}
            <TimelineElement>&nbsp;</TimelineElement>
            {timelineElements.map(([title, content], index) => (
              <TimelineElement key={index} index={index + 1} right={index % 2 !== 0}>
                <h3 className="timeline-title mb-0">{title}</h3>
                <p className="mt-3 timelineContent">{content}</p>
              </TimelineElement>
            ))}
          </Timeline>
        </Container>
      </div>

      {/* SECTION: "Jouw groeipotentieel" */}
      <ContentSection
        header={formatMessage({ id: 'jumptosynergie_consultants_section3_title' })}
        image={
          <img
            src="/images/jump-to-synergie/jump_interview.jpg"
            alt="Collega's staan voor een gebouw"
            className="img-fluid mx-0"
          />
        }
        content={
          <>
            <p>{formatMessage({ id: 'jumptosynergie_consultants_section3_p1' })}</p>
            <p>{formatMessage({ id: 'jumptosynergie_consultants_section3_p2' })}</p>
          </>
        }
      />

      {/* TESTIMONIAL */}
      <Container className="my-4 p-lg-5" tag="section">
        {/* <Card className="p-5"> */}
        <TestimonialTile
          quote={formatMessage({
            id: `jumptosynergie_section4_quote_${locale === 'nl' ? 'anouk' : 'joyce'}`,
          })}
          name={formatMessage({
            id: `jumptosynergie_section4_name_${locale === 'nl' ? 'anouk' : 'joyce'}`,
          })}
          imagePath={`/images/jump-to-synergie/jump_quote_${locale === 'nl' ? 'anouk' : 'joyce'}.jpg`}
          position={formatMessage({
            id: `jumptosynergie_section4_position_${locale === 'nl' ? 'anouk' : 'joyce'}`,
          })}
          quoteColor="var(--bs-warning)"
        />
        {/* </Card> */}
      </Container>

      {/* SECTION: "Inhoud van je rol" */}
      <div className="bg-light">
        <ContentSection
          flip
          header={formatMessage({ id: 'jumptosynergie_consultants_section5_title' })}
          image={
            <img
              src="/images/jump-to-synergie/jump_consultant_collegas.jpg"
              alt="Synergie collega's"
              className="img-fluid mx-0"
            />
          }
          content={
            <ul className="checkedList">
              <li className="mb-3">{formatMessage({ id: 'jumptosynergie_consultants_section5_li1' })}</li>
              <li className="mb-3">{formatMessage({ id: 'jumptosynergie_consultants_section5_li2' })}</li>
              <li className="mb-3">{formatMessage({ id: 'jumptosynergie_consultants_section5_li3' })}</li>
              <li className="mb-3">{formatMessage({ id: 'jumptosynergie_consultants_section5_li4' })}</li>
            </ul>
          }
        />
      </div>

      {/* SECTION: "Voordelen" */}
      <ContentSection
        header={formatMessage({ id: 'jumptosynergie_section6_title' })}
        image={
          <img
            src="/images/waarom_careers_header_employers.jpg"
            alt="Vrouw staat aan een Kanban-bord"
            className="img-fluid mx-0"
          />
        }
        content={
          <ul className="checkedList">
            <li className="mb-3">{formatMessage({ id: 'jumptosynergie_consultants_section6_li1' })}</li>
            <li className="mb-3">{formatMessage({ id: 'jumptosynergie_consultants_section6_li2' })}</li>
            <li className="mb-3">{formatMessage({ id: 'jumptosynergie_consultants_section6_li3' })}</li>
            <li className="mb-3">{formatMessage({ id: 'jumptosynergie_consultants_section6_li4' })}</li>
            <li className="mb-3">{formatMessage({ id: 'jumptosynergie_consultants_section6_li5' })}</li>
          </ul>
        }
      />

      {/* SECTION: "Verwachtingen" */}
      <div className="bg-light">
        <ContentSection
          flip
          header={formatMessage({ id: 'jumptosynergie_section7_title' })}
          image={
            <div className="d-flex justify-content-center mt-5  ">
              <CandidateSearchIcon />
            </div>
          }
          content={
            <>
              {locale === 'fr' && <p>{formatMessage({ id: 'jumptosynergie_consultants_section7_p' })}</p>}
              <ul className="checkedList">
                <li className="mb-3">{formatMessage({ id: 'jumptosynergie_consultants_section7_li1' })}</li>
                {locale === 'nl' && (
                  <li className="mb-3">{formatMessage({ id: 'jumptosynergie_consultants_section7_li1.5' })}</li>
                )}
                <li className="mb-3">{formatMessage({ id: 'jumptosynergie_consultants_section7_li2' })}</li>
                <li className="mb-3">{formatMessage({ id: 'jumptosynergie_consultants_section7_li3' })}</li>
                <li className="mb-3">{formatMessage({ id: 'jumptosynergie_consultants_section7_li4' })}</li>
                <li className="mb-3">{formatMessage({ id: 'jumptosynergie_consultants_section7_li5' })}</li>
                <li className="mb-3">{formatMessage({ id: 'jumptosynergie_consultants_section7_li6' })}</li>
              </ul>
            </>
          }
        />
      </div>

      {/* OUTRO: Registration form */}
      <Container tag="article" className="py-5">
        <Row className="py-lg-4" id="registrationForm-section">
          <Col lg="5" className="mb-4">
            <h2 className="py-2 mb-4">{formatMessage({ id: 'jumptosynergie_cta' })}</h2>
            <p>{formatMessage({ id: 'jumptosynergie_consultants_section8_title' })}</p>
            <p>{formatMessage({ id: 'jumptosynergie_consultants_section8_p' })}</p>
            {locale === 'nl' && (
              <Link href={`/${locale}/jump-to-synergie/managers/`}>{formatMessage({ id: 'jumptosynergie_cta_discover' })}</Link>
            )}
          </Col>
          <Col lg={{ size: 6, offset: 1 }}>
            <RegistrationForm dictionary={dictionary} id="jumpToSynergie_registration" source="jumpToSynergieConsultants" />
          </Col>
        </Row>
      </Container>

      {/* Floating action button: "Ik schrijf me in" */}
      <div
        style={{
          zIndex: '1',
        }}
        className={`${fabDisplayClass} floating-action-container d-flex justify-content-center justify-content-md-end mb-3`}
      >
        <Button color="warning" className="px-5 floating-action-button" onClick={scrollToForm}>
          <strong>{formatMessage({ id: 'jumptosynergie_cta' })}</strong>
        </Button>
      </div>
    </AppLayout>
  );
}
